<template>
    <div id="hradContainer">
        <div>
            <img src="../../assets/imgs/LOGO.png" id="logo-img">
            <el-menu
                :default-active="this.$store.state.activeIndex"
                class="el-menu-demo"
                mode="horizontal"
                text-color="#b9b9b9"
                active-text-color="#58bcf8"
                :router="true">
                <el-menu-item index="/">首页</el-menu-item>
                <el-menu-item index="/introduction">公司简介</el-menu-item>
                <el-menu-item index="/news">新闻中心</el-menu-item>
                <el-menu-item index="/service">解决方案</el-menu-item>
                <el-menu-item index="/product?id=0">产品展示</el-menu-item>
                <el-menu-item index="/case">客户案例</el-menu-item>
                <el-menu-item index="/contact">联系我们</el-menu-item>
            </el-menu>
        </div>
    </div>
</template>

<script>
export default {
    name:'ShareHead', 
    methods: {
        handleScroll(e){
            // 距离顶部距离
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            let divBg = document.getElementById('hradContainer'); 
            if(scrollTop > 150){
                // divBg.style = 'background:rgba(0,19,34,.8)'
                divBg.style = 'background:rgba(19, 10, 82,1)'
            }else{
                divBg.style = 'background:transparent'
            }
        }  
    },
    mounted: function () {
        window.addEventListener('scroll', this.handleScroll, true);  // 监听（绑定）滚轮滚动事件
    }
}
</script>

<style scoped>
    #hradContainer{
        overflow: hidden;
        display: flex;                      /*定位（写在父元素中）*/
        justify-content:center;           /*水平居中*/
        align-items:Center;   
        position: fixed;
        width: 100%;
        min-width: 1120px;
        top: 0;
        z-index: 18;
    }
    #hradContainer .el-menu-item{
        padding: 0 20px;
        margin: 0 17px;
    }
    #hradContainer>div{
        width: 1010px;
    }
    .el-menu.el-menu--horizontal{
        border-bottom: 0;
        float: left;
        background: transparent;
    }
    #logo-img{
        float: left;
        margin-right: 10px;
        margin-top: 10px;
    }
    .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover{
        background: transparent;
        
    }
    .el-menu--horizontal>.el-menu-item{
        height: 60px;
        line-height: 60px;
    }
</style>
